


































import Vue from "vue"
import moment from "moment"
import {AxiosResponse} from "axios"
import {saveAs} from "file-saver"

export default Vue.extend({
  components: {},
  data() {
    return {
      selfReportDate: new Date()
    }
  },
  props: {},
  methods: {
    selfReportCod() {
      const vm = this
      vm.startLoad()
      const date = moment(this.selfReportDate).valueOf()
      this.$http({
        method: "get",
        url: "/parcel/self_report_cod",
        params: {
          date: date
        },
        responseType: "arraybuffer"
      })
        .then((response: any) => {
          vm.endLoad()
          vm.selfReportDate = new Date()
          vm.handleFileDownload(response)
        })
        .catch(() => {
          vm.endLoad()
        })
    },
    selfReport() {
      const vm = this
      vm.startLoad()
      const date = moment(this.selfReportDate).valueOf()
      this.$http({
        method: "get",
        url: "/parcel/self_report",
        params: {
          date: date
        },
        responseType: "arraybuffer"
      })
        .then((response: any) => {
          vm.endLoad()
          vm.selfReportDate = new Date()
          vm.handleFileDownload(response)
        })
        .catch(() => {
          vm.endLoad()
        })
    },
    handleFileDownload(response: AxiosResponse<any>) {
      const contentType = response.headers["content-type"]
      const blob = new Blob(["\ufeff", response.data], {type: contentType})
      const filename = response.headers["content-disposition"].match(/attachment; filename=(.*)/)[1]
      saveAs(blob, filename)
    }
  }
})
